var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgConferences = function SvgConferences(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 32 34"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor",
    fillRule: "evenodd",
    clipPath: "url(#conferences_svg__a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.994 17.5h23.05l4.365-4.234a1.93 1.93 0 0 0 0-2.785l-1.45-1.406c-1.594 1.546-4.177 1.546-5.77 0a3.874 3.874 0 0 1 0-5.596l-1.45-1.406a2.075 2.075 0 0 0-2.87 0L2.188 17.28a2 2 0 0 0-.195.219Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 17.5a2 2 0 0 0-2 2V21c0 .276.225.497.499.53a4 4 0 0 1 0 7.94C.225 29.503 0 29.724 0 30v1.5a2 2 0 0 0 2 2h28a2 2 0 0 0 2-2V30c0-.276-.225-.497-.499-.53a4 4 0 0 1 0-7.94c.274-.033.499-.254.499-.53v-1.5a2 2 0 0 0-2-2zm15.871 6.75-1.282-3.392a.663.663 0 0 0-1.176 0l-1.283 3.393h-2.495a.608.608 0 0 0-.619.751.6.6 0 0 0 .19.318l2.165 1.512-1.2 2.761a.656.656 0 0 0 .54.904.65.65 0 0 0 .39-.085l2.9-1.634 2.9 1.634a.652.652 0 0 0 .93-.819l-1.2-2.76 2.165-1.513a.612.612 0 0 0-.43-1.07z",
    opacity: 0.4
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "conferences_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 .5h32v33H0z"
  })))));
};
export default SvgConferences;